import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { fetchMatchDates as fetchMatchDatesApi } from '@apis/matchDates';
import type { RoundPhase } from '@shared-types/match.types';
import { dateToString } from '@utilities/dateTime';

export const fetchMatchDates = (
  {
    competitionIds,
    seasonYear,
    startDate,
    endDate,
    phase,
  }: {
    competitionIds: string[];
    seasonYear?: string;
    startDate: Dayjs;
    endDate: Dayjs;
    phase?: RoundPhase | 'ALL';
  },
  signal: AbortSignal,
) => {
  const filters = {
    competitionIds,
    seasonYear,
    phase,
    startDate: dateToString(startDate),
    endDate: dateToString(endDate),
    utcOffset: Math.max(dayjs().utcOffset(), dayjs().add(6, 'months').utcOffset()) / 60,
  };
  return fetchMatchDatesApi(filters, signal);
};
